import { useEffect, useContext } from 'react';
import { FundContext } from '../FundPage';
import PageGridItem from '../../../Shared/Page/PageGridItem';
import DynamicDetails from '../DynamicDetails';
import "../FundPage.scss"


const FundTab = ({ group, name, cancelledChanges }) => {
	const { fund, editMode, setSelectedTab, staticData, setStaticData, config } = useContext(FundContext)
	fund.number = fund.fundNumber;
	fund.name = fund.fundName;

	useEffect(() => {
		setSelectedTab(name)
	}, [])

	function updateStaticData(key, value) {
		let updatedArr = []
		if (staticData.find(e => e.key === key)) {
			updatedArr = staticData.map(e => {
				if (e.key === key) {
					return { ...e, value: value }
				} else return e
			})
		} else {
			updatedArr = [...staticData, { key, value }]
		}
		setStaticData(updatedArr)
	}

	return (
		<>
			<PageGridItem container col="1 / span 12" direction='col' gap="xl" style={{ display: 'flex', maxWidth: "1000px" }}>
				<DynamicDetails
					editMode={editMode}
					portfolio={fund}
					staticData={staticData}
					config={config}
					group={group}
					updateStaticData={updateStaticData}
					name={name}
					cancelledChanges={cancelledChanges}
				/>
			</PageGridItem>
		</>
	);
}

export default FundTab;
